export default __webpack_public_path__ + "static/media/starryBackground.1cce885a.jpeg";